export var TipoParcelaImovelEnum;
(function (TipoParcelaImovelEnum) {
    TipoParcelaImovelEnum["NORMAL"] = "NORMAL";
    TipoParcelaImovelEnum["CONCEDIDO"] = "CONCEDIDO";
})(TipoParcelaImovelEnum || (TipoParcelaImovelEnum = {}));
(function (TipoParcelaImovelEnum) {
    var mapDescricao = new Map([
        [TipoParcelaImovelEnum.NORMAL, 'Normal'],
        [TipoParcelaImovelEnum.CONCEDIDO, 'Concedido'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    TipoParcelaImovelEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    TipoParcelaImovelEnum.getOptions = getOptions;
})(TipoParcelaImovelEnum || (TipoParcelaImovelEnum = {}));
